// @ts-nocheck

import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import {
  fetchPublicSurveyDetailCall,
  submitPublicSurveyDataCall,
} from '../../../actions/survey.action'
import CustomSurvey from '../../../components/sis/student/survey/CustomSurvey'
import { ROUTES } from '../../../helpers/constants'
import { selectSchool } from '../../../helpers/selectors'
import { getSchoolUrl, isEmpty, noop } from '../../../helpers/utils'
import withRouteContext from '../../../hocs/RouterContextHOC'
import withStudentDetails from '../../../hocs/withStudentDetailHOC'

function CustomSurveyContainer({
  school,
  fetchPublicSurveyDetailCall,
  submitPublicSurveyDataCall,
}) {
  const history = useHistory()
  const params = useParams()
  const { id } = useParams()
  const [surveysDetails, setSurveysDetails] = React.useState([])
  const [isSurveySubmitted, setIsSurveySubmitted] = React.useState(false)

  const getSurveysDetails = () => {
    fetchPublicSurveyDetailCall(id, (data) => {
      if (!data.sr_access_levels.includes('Custom') || data.sr_status !== 'publish') {
        history.replace(getSchoolUrl({ ...params, to: ROUTES.NOTFOUND }))
      }
      setSurveysDetails(data)
    })
  }

  const onCloseConfirm = () => {
    setIsSurveySubmitted(false)
    const relativePath = getSchoolUrl({
      ...params,
      to: `${ROUTES.LOGIN}`,
    })
    history.replace(relativePath)
  }

  const handleFormSubmit = (formData) => {
    const payload = {
      sud_survey_id: id,
      sud_survey_type: 'school',
      sud_survey_type_id: school.sch_school_public_id,
      sud_response_content: formData,
    }
    submitPublicSurveyDataCall(
      payload,
      () => {
        setIsSurveySubmitted(true)
      },
      () => {}
    )
  }

  React.useEffect(() => {
    if (!isEmpty(school)) {
      getSurveysDetails()
    }
  }, [school])

  React.useEffect(() => {
    if (isSurveySubmitted) {
      setTimeout(() => {
        setIsSurveySubmitted(false)
        const relativePath = getSchoolUrl({
          ...params,
          to: `${ROUTES.LOGIN}`,
        })
        history.replace(relativePath)
      }, '5000')
    }
  }, [isSurveySubmitted])

  return (
    <CustomSurvey
      school={school}
      surveysDetails={surveysDetails}
      handleFormSubmit={handleFormSubmit}
      isSurveySubmitted={isSurveySubmitted}
      onCloseConfirm={onCloseConfirm}
    />
  )
}

CustomSurveyContainer.propTypes = {
  school: PropTypes.object,
  fetchPublicSurveyDetailCall: PropTypes.func,
  submitPublicSurveyDataCall: PropTypes.func,
}

CustomSurveyContainer.defaultProps = {
  school: {},
  fetchPublicSurveyDetailCall: noop,
  submitPublicSurveyDataCall: noop,
}

const mapStateToProps = (state) => ({
  school: selectSchool(state),
})

export default withStudentDetails(
  withRouteContext(
    connect(mapStateToProps, {
      fetchPublicSurveyDetailCall,
      submitPublicSurveyDataCall,
    })(CustomSurveyContainer)
  )
)
